import styled from 'styled-components';

export const SectionSpaceLarge = styled.div`
  margin-top: 6rem;
  @media (max-width: 40rem){
    margin-top: 4rem;
  }
`
export const SectionSpaceMedium = styled.div`
  margin-top: 4rem;
`
export const SectionSpaceSmall = styled.div`
  margin-top: 3rem;
`
export const SectionSpaceExtraSmall = styled.div`
  margin-top: 2rem;
`

